import { AccountCashflow } from '../type';

export const cashflowLineHasRefund = (cashflowLine: AccountCashflow | null | undefined) => (cashflowLine ? cashflowLine['S_ACC.OBL_END_DATE'] === cashflowLine['CPS_HIS.DETACHE_DATE'] : false);
